import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  return (
    <section id="guides" className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
            Everything You Need About Basetao Spreadsheet
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed">
            A <strong>Basetao spreadsheet</strong> is an essential organizational tool designed to help international shoppers track, compare, and manage their product discoveries efficiently. Unlike scattered browser bookmarks or random notes, a well-structured Basetao spreadsheet brings clarity to your entire shopping workflow — from initial product research to final purchase decisions. Whether you are hunting for the latest sneaker releases, comparing hoodie quality across multiple sellers, or calculating shipping costs for a bulk order, having a dedicated spreadsheet resource transforms an overwhelming process into a streamlined experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12">
          {[
            {
              title: 'Basetao Spreadsheet',
              desc: 'Find categorized resources and product research guides organized by category, price range, and seller reputation.',
              icon: 'ri-file-list-3-line',
            },
            {
              title: 'Basetao Review',
              desc: 'Understand real user experiences, platform advantages, limitations, and how the service compares to alternatives.',
              icon: 'ri-star-line',
            },
            {
              title: 'Basetao Shipping Cost',
              desc: 'Learn about shipping methods, estimated costs by weight and destination, and practical optimization tips to reduce expenses.',
              icon: 'ri-ship-line',
            },
            {
              title: 'Basetao Warehouse',
              desc: 'Understand storage procedures, QC photo workflows, parcel consolidation, and effective warehouse management strategies.',
              icon: 'ri-store-2-line',
            },
            {
              title: 'Basetao Coupon',
              desc: 'Find currently available promotions, seasonal discount opportunities, and strategies to maximize your savings on every order.',
              icon: 'ri-coupon-line',
            },
            {
              title: 'Is Basetao Legit?',
              desc: 'Learn how to verify platform safety, identify trusted sellers, and protect yourself throughout the purchasing process.',
              icon: 'ri-shield-check-line',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-accent-300/50"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-600">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center p-8 rounded-2xl bg-background-50 border border-background-200/70">
          <h3 className="font-heading text-xl font-bold text-foreground-900 mb-3">
            Want to Learn More About Basetao Spreadsheets?
          </h3>
          <p className="text-sm text-foreground-600 mb-6 max-w-lg mx-auto">
            Read our comprehensive guide covering everything from getting started to advanced spreadsheet strategies for power users.
          </p>
          <Link
            to="/basetao-spreadsheet-guide"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-7 py-3 rounded-full bg-accent-500 text-white text-sm font-semibold transition-all duration-300 hover:bg-accent-600"
          >
            Read the Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}